import { NgModule } from '@angular/core';
import { CapitalizeWordsPipe } from './pipes/capitalize-words.pipe';

@NgModule({
  imports: [CapitalizeWordsPipe],
  exports: [CapitalizeWordsPipe]
})
export class PipesModule {}
